module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppBlockWrapper', [_c('BreadcrumbsLayout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [(_vm.nothingFound) ? _c('PageError') : _c('AppCardTotalLayout', [_c('AppHeading', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v(_vm._s(_vm.name))]), _c('AppPicture', {
    attrs: {
      "slot": "slider",
      "image": _vm.image,
      "alt": _vm.name
    },
    slot: "slider"
  }), _c('template', {
    slot: "sidebar"
  }, [(_vm.competenceBlockName) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Блок компетенций:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.competenceBlockName))])], 1) : _vm._e(), (_vm.sidebar && _vm.sidebar.cisNumber) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Номер:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.sidebar.cisNumber))])], 1) : _vm._e(), (_vm.sidebar && _vm.sidebar.creatorComp) ? _c('div', [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v("Разработчик компетенции:")]), _c('AppText', {
    attrs: {
      "mod": "small"
    }
  }, [_vm._v(_vm._s(_vm.sidebar.creatorComp))])], 1) : _vm._e()]), _c('template', {
    slot: "main"
  }, [(_vm.main && _vm.main.description) ? _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.main.description
    }
  }) : _vm._e(), (_vm.main && _vm.main.evaluationCompCriterion) ? _c('AppCardDescriptionBlockLayout', [_c('AppTypeIcon', {
    attrs: {
      "type": "base"
    }
  }), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, bottom"
    }
  }, [_vm._v("Критерии оценки")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.main.evaluationCompCriterion
    }
  })], 1) : _vm._e(), (_vm.competenceModules.length) ? _c('AppCardDescriptionBlockLayout', [_c('AppTypeIcon', {
    attrs: {
      "type": "doc"
    }
  }), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, bottom"
    }
  }, [_vm._v("Модули компетенции")]), _c('AppList', {
    attrs: {
      "items": _vm.competenceModules
    }
  })], 1) : _vm._e()], 1)], 2)], 1), (_vm.listOfCards.length) ? _c('ExtraLayout', {
    attrs: {
      "bg": "gray"
    }
  }, _vm._l((_vm.listOfCards), function(item) {
    return _c('AppCardsList', _vm._b({
      key: item.title
    }, 'AppCardsList', item, false))
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa758f1","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/competences/card/CompetenceCard.vue
// module id = 5724d3222a22e3d3bf69
// module chunks = 49